import type { Timeframe } from "../types";

export const TIMEFRAMES: Timeframe[] = [
  { id: "1s", label: "1s", kind: "sec", seconds: 1 }, // synthetic tick candles: one candle per source tick (see TickAggregator)
  { id: "5s", label: "5s", kind: "sec", seconds: 5 },
  { id: "15s", label: "15s", kind: "sec", seconds: 15 },
  { id: "30s", label: "30s", kind: "sec", seconds: 30 },
  { id: "1m", label: "1m", kind: "candle", seconds: 60 },
  { id: "5m", label: "5m", kind: "candle", seconds: 300 },
  { id: "15m", label: "15m", kind: "candle", seconds: 900 },
  { id: "1h", label: "1h", kind: "candle", seconds: 3600 },
  { id: "4h", label: "4h", kind: "candle", seconds: 14400 },
  { id: "1D", label: "D", kind: "candle", seconds: 86400 },
];

export const TICK_TIMEFRAMES: Timeframe[] = [
  { id: "T10", label: "10T", kind: "tick", ticks: 10 },
  { id: "T25", label: "25T", kind: "tick", ticks: 25 },
  { id: "T50", label: "50T", kind: "tick", ticks: 50 },
  { id: "T100", label: "100T", kind: "tick", ticks: 100 },
  { id: "T250", label: "250T", kind: "tick", ticks: 250 },
];

export const ALL_TF: Timeframe[] = [...TIMEFRAMES, ...TICK_TIMEFRAMES];

export function getTf(id: string): Timeframe {
  return ALL_TF.find((t) => t.id === id) || TIMEFRAMES[0];
}
